

    import Vue from "vue";
    import { Component, Prop, Watch } from "vue-property-decorator";
    import { Route } from "vue-router"
    import MenuItem from "../../../models/menuItem";
    import MenuFactory from "../../../models/menu"

    @Component
    export default  class MenuComponent extends Vue {

        menuList: Array<MenuItem> = MenuFactory.getProjectMenu();
        routers: Array<Route> = [];

        burgerActive: boolean = true
    }
    
